import _class_call_check from "@swc/helpers/src/_class_call_check.mjs";
import _inherits from "@swc/helpers/src/_inherits.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _create_super from "@swc/helpers/src/_create_super.mjs";
import { toFormat } from "./BoundFormat.js";
import { isMissingValue } from "../../api/Missing.js";
export var MissingFormat = /*#__PURE__*/ function() {
    "use strict";
    function MissingFormat(wrapped, options) {
        _class_call_check(this, MissingFormat);
        var ref;
        Object.defineProperties(this, {
            format: {
                value: this.format.bind(this)
            },
            wrapped: {
                value: toFormat(wrapped)
            },
            missing: {
                value: (ref = options === null || options === void 0 ? void 0 : options.missing) !== null && ref !== void 0 ? ref : ""
            }
        });
    }
    var _proto = MissingFormat.prototype;
    _proto.format = function format(value) {
        return isMissingValue(value) ? this.missing : this.wrapped.format(value);
    };
    _proto.resolvedOptions = function resolvedOptions() {
        return {
            missing: this.missing
        };
    };
    return MissingFormat;
}();
export var MissingFormatWithOptions = /*#__PURE__*/ function(MissingFormat) {
    "use strict";
    _inherits(MissingFormatWithOptions, MissingFormat);
    var _super = _create_super(MissingFormatWithOptions);
    function MissingFormatWithOptions(wrapped, options) {
        _class_call_check(this, MissingFormatWithOptions);
        return _super.call(this, wrapped, options);
    }
    var _proto = MissingFormatWithOptions.prototype;
    _proto.resolvedOptions = function resolvedOptions() {
        return _object_spread_props(_object_spread({}, this.wrapped.resolvedOptions()), {
            missing: this.missing
        });
    };
    return MissingFormatWithOptions;
}(MissingFormat);
export var MissingFormatToParts = /*#__PURE__*/ function(MissingFormatWithOptions) {
    "use strict";
    _inherits(MissingFormatToParts, MissingFormatWithOptions);
    var _super = _create_super(MissingFormatToParts);
    function MissingFormatToParts(wrapped, options) {
        _class_call_check(this, MissingFormatToParts);
        return _super.call(this, wrapped, options);
    }
    var _proto = MissingFormatToParts.prototype;
    _proto.formatToParts = function formatToParts(value) {
        if (isMissingValue(value)) {
            return [
                {
                    type: "missing",
                    value: this.missing
                }
            ];
        }
        return this.wrapped.formatToParts(value);
    };
    return MissingFormatToParts;
}(MissingFormatWithOptions);
export var MissingFormatRange = /*#__PURE__*/ function(MissingFormatToParts) {
    "use strict";
    _inherits(MissingFormatRange, MissingFormatToParts);
    var _super = _create_super(MissingFormatRange);
    function MissingFormatRange(wrapped, options) {
        _class_call_check(this, MissingFormatRange);
        return _super.call(this, wrapped, options);
    }
    var _proto = MissingFormatRange.prototype;
    _proto.formatRange = function formatRange(start, end) {
        return this.wrapped.formatRange(start, end);
    };
    _proto.formatRangeToParts = function formatRangeToParts(start, end) {
        return this.wrapped.formatRangeToParts(start, end);
    };
    return MissingFormatRange;
}(MissingFormatToParts);

//# sourceMappingURL=MissingFormat.js.map